// Utils
import { isPastDate } from '../../../utils/date';
import isProductExpired from '../../../utils/isProductExpired';
import isProductWithdrawn from '../../../utils/isProductWithdrawn';

const EXCLUDED_INACTIVE_OPTION_KEYWORDS = ['Expired', 'Withdrawn'];

const isInactiveWithoutAvailableFilter = (product, isCheckedAvailable) =>
  !isCheckedAvailable && !!product?.offer_inactive;

const isInactiveExcludedByAvailableFilter = (
  product,
  checkedAvailableOption,
) => {
  if (!checkedAvailableOption) {
    return false;
  }

  const isExpiredOrWithdrawnOption = EXCLUDED_INACTIVE_OPTION_KEYWORDS.some(
    (keyword) => checkedAvailableOption.title?.includes(keyword),
  );

  return !isExpiredOrWithdrawnOption && !!product?.offer_inactive;
};

const isPastEndDateAndStillActive = (product) => {
  if (isProductWithdrawn(product) || isProductExpired(product)) {
    return false;
  }

  return product.end_date ? isPastDate(new Date(product.end_date)) : false;
};

const isActiveAndAvailable = (product, filters) => {
  const checkedAvailableOption = filters.available.find((item) => item.checked);
  const isCheckedAvailable = !!checkedAvailableOption;

  const isUnavailable =
    isInactiveWithoutAvailableFilter(product, isCheckedAvailable) ||
    isInactiveExcludedByAvailableFilter(product, checkedAvailableOption) ||
    isPastEndDateAndStillActive(product);

  return !isUnavailable;
};

export default isActiveAndAvailable;
